import 'app/helpers/elements'
import 'modules/helpers'

window.App ?= {}
window.App._page_contexts = {}

class window.App.WindowManager
  constructor: (element) ->
    App.load_initial_context()

    @_page_content = document.querySelector(".document-main")
    @_page_navbar = document.getElementById("global_page_navbar")
    @_page_sidebar = document.getElementById("document-sidebar")

    @deferred_requests = {}
    @timers = {}
    @timer_cache_length = 30

    if @windowing_enabled()
      $(document).on "click", "[data-object], [data-window]", (event) =>
        return if event.currentTarget.target == "_blank"
        event.preventDefault()
        @open(event)

      $(document).on "mousedown", "[data-object], [data-window]", (event) =>
        return if event.currentTarget.target == "_blank"
        @load(event)

      # if App.current_user.config_or_true("responses", "views", "preload", "hover")
      if false
        $(document).on "mouseover", "[data-object], [data-window]", (event) =>
          return if event.currentTarget.target == "_blank"
          @load(event)

      window.onpopstate = (event) => @navigate(event)

      parser = App.Helpers.URIs.parse(window.location.toString())
      parser.set_param("display", undefined)
      path = parser.path()

      if window.history? && window.history.replaceState?
        state_path = App.WindowContext.slash_path(path)
        window.history.replaceState({ "path": state_path, "title": document.title }, document.title, state_path)

  windowing_enabled: ->
    return false if App.Helpers.Compatibility.is_ie == true
    current_user.guest() || current_user.config("responses", "views", "single_page")

  timeout_expired: (path) ->
    return true unless @timers[path]?
    @timers[path] < App.Helpers.Times.unix()

  set_timeout: (path) ->
    @timers[path] = App.Helpers.Times.unix() + @timer_cache_length

  request_page: (path, refresh, suppress_errors, object_type) ->
    path = App.context_path(path)

    if @deferred_requests[path]?
      @deferred_requests[path].then (context) =>
        @set_timeout(path) if refresh && @timeout_expired(path)

      return @deferred_requests[path]

    @deferred_requests[path] = new Promise (resolve, reject) =>
      page_exists = @_page_content.querySelector(".main_view_page[data-page-path='#{path}']")?

      if page_exists
       resolve(App.context(path))
      else
        @load_request(path, null, object_type).then (context) =>
          resolve(context)
        .catch (xhr) =>
          App.Errors.xhr_error(xhr) unless suppress_errors
          @deferred_requests[path] = undefined

  load_request: (path, context = null, object_type = null) ->
    new Promise (resolve, reject) =>
      path = App.context_path(path)

      headers = {}
      headers["X-Display"] = "scaffold"

      objects = App.loaded_context_elements(object_type)

      if objects.sidebars?
        headers["X-Loaded-Sidebars"] = JSON.stringify(objects.sidebars)

      $.ajax
        url: path
        dataType: "html"
        headers: headers
      .done (response, status, xhr) =>
        headers = {}
        headers["x-loaded-sidebar"] = xhr.getResponseHeader("x-loaded-sidebar")

        resolve @load_response(path, response, context, headers)
      .fail reject

  load_response: (path, response, context = undefined, headers = {}) ->
    path = App.context_path(path)

    context ?= new App.WindowContext(path)

    response_xml = document.createElement("DIV")
    response_xml.innerHTML = response

    page_title = response_xml.querySelector("page > title")
    page_title ?= document.createElement("DIV")

    page_navbar = response_xml.querySelector("page > navbar")
    page_navbar ?= document.createElement("DIV")

    page_content = response_xml.querySelector("page > content")
    page_content ?= document.createElement("DIV")

    page_sidebar = response_xml.querySelector("page > sidebar")

    context.title = page_title.innerHTML

    main_view_class = "main_view_page"
    page_content_class = page_content.getAttribute("data-view-class")

    if page_content_class? && page_content_class.length > 0
      main_view_class += " #{page_content_class}"

    page_node = document.createElement("DIV")
    page_node.className = main_view_class
    page_node.dataset.pagePath = path
    page_node.innerHTML = page_content.innerHTML

    context._page_element.remove() if context._page_element?
    context._page_element = page_node

    menu_node = document.createElement("DIV")
    menu_node.className = "navbar context"
    menu_node.dataset.pagePath = path
    menu_node.innerHTML = page_navbar.innerHTML

    context._menu_element.remove() if context._menu_element?
    context._menu_element = menu_node

    if headers? && headers["x-loaded-sidebar"]?
      parsed_context = JSON.parse(headers["x-loaded-sidebar"])

      loaded_contexts = App.loaded_context_elements("all", false)
      loaded_contexts_with_models = App.loaded_context_elements("all", true)

      for ctx, index in loaded_contexts.sidebars
        if App.Helpers.Objects.isEquivalent(parsed_context, ctx)
          model = loaded_contexts_with_models.sidebars[index].model
          context._sidebar_element = model.element

    else if page_sidebar?
      sidebar_node = page_sidebar.querySelector(".page-sidebar")
      sidebar_node.dataset.pagePath = path

      if context._sidebar_element?
        old_sidebar_element = context._sidebar_element

        # Contexts can share elements
        for other_context in App.WindowContext.all()
          if other_context._sidebar_element == old_sidebar_element
            other_context._sidebar_element = sidebar_node

        old_sidebar_element.remove()

      context._sidebar_element = sidebar_node

      App.Interface.Sidebar.add(sidebar_node)

    new App.Interface.Menu.MenuBar(context._menu_element)

    @set_timeout(path)

    $(document).trigger("page:load", context)

    context.attach(except: App.context())

    context._page_element.dispatchEvent new CustomEvent("page:ready", {
      bubbles: false,
      cancelable: false
    })

    context

  load_page: (path, visible, refresh, suppress_errors = false, object_type = null) ->
    @request_page(path, refresh, suppress_errors, object_type).then (context) =>
      if visible
        context.show()

        App.Interface.Modal.hide_all()

      context

  open_page: (path, object_type) ->
    new Promise (resolve, reject) =>
      return App.hard_redirect_to(path) unless @windowing_enabled()

      @load_page(path, true, false, false, object_type).then (context) =>
        App.WindowManager.select_sidebar_options(path)

        if window.history? && window.history.pushState?
          state_path = App.WindowContext.slash_path(path)
          window.history.pushState({ "path": state_path, "title": context.title }, context.title, state_path)
          document.title = context.title

        $(document).trigger("page:open", context)

        resolve(context)
      .catch =>
        reject()

  open: (event_or_path) ->
    App.Helpers.Loaders.start_cursor()

    if App.Helpers.Objects.isEvent(event_or_path)
      event_or_path.preventDefault()

      link = event_or_path.currentTarget

      App.WindowManager.assign_section_tab(link.dataset.object)

      promise = @open_page(link.href, link.dataset.object)
    else
      promise = @open_page(event_or_path)

    promise_is_loading = true

    promise
    .then (context) ->
      promise_is_loading = false
      App.Helpers.Loaders.finish_page()
      App.Helpers.Loaders.finish_cursor()
    .catch ->
      promise_is_loading = false
      App.Helpers.Loaders.finish_page()
      App.Helpers.Loaders.finish_cursor()

    setTimeout((-> App.Helpers.Loaders.start_page() if promise_is_loading), 100)

    promise

  load: (event_or_path) ->
    return Promise.reject() unless @windowing_enabled()

    if App.Helpers.Objects.isEvent(event_or_path)
      link = event_or_path.currentTarget
      @load_page(link.href, false, false, true, link.dataset.object)
    else
      @load_page(event_or_path, false, false, true)

  navigate: (event) ->
    if event.state?
      @load_page(event.state.path, true, false)
      document.title = event.state.title

      App.WindowManager.select_sidebar_options(event.state.path)

  hide_all: ->
    App.WindowContext.hide_all()

  hide_all_except: (model) ->
    App.WindowContext.hide_all_except(model)

  @select_sidebar_options: (path) ->
    sidebar_options = document.querySelectorAll(".sidebar-option")

    for option in sidebar_options
      option.classList.toggle("selected", path == option.href)

    undefined

  @forms_section_objects: ["form", "report", "calendar", "custom_form_view", "custom_dashboard_view", "custom_submission_view", "grouping.set"]

  @assign_section_tab: (object_type) ->
    if App.WindowManager.forms_section_objects.indexOf(object_type) != -1
      head_navbar = document.querySelector(".navbar.head")
      head_options = head_navbar.querySelectorAll(".option")

      for option in head_options
        form_option = option.classList.contains("form_option")
        option.classList.toggle("selected", form_option)

$ ->
  window.App.window_manager ?= new App.WindowManager()

  $(document).trigger("page:manager:start")

  for page in document.querySelectorAll(".main_view_page")
    page_path = page.getAttribute("data-page-path")

    $(document).trigger("page:load", App.context(page_path))

    page.dispatchEvent new CustomEvent("page:ready", {
      bubbles: false,
      cancelable: false
    })

  App._generate_scrollbars()

$(document).on "page:load", (event, context) ->
  menu_element = $(context._menu_element)

  for table_element in context._page_element.querySelectorAll(".table_container:not(.manual_initialization)")
    table = App.tables.add(table_element)

    if table.params.search?
      table.params.search(menu_element.find(".table-search"))

    if table.params.length?
      table.params.length(menu_element.find(".table-length"))

  for submission in context._page_element.querySelectorAll(".SUBMISSION:not(.initialized)")
    App.Models.Form.new(submission.dataset.formPermalink).submissions.initialize_element($(submission))

  for calendar in context._page_element.querySelectorAll(".calendar_wrapper:not(.initialized)")
    App.Elements.ResponseCalendar.new(calendar)

  $(context._page_element).detect_links()
